/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ExportColumnGroupEnumType } from "./ExportColumnGroupEnum"
import { RootStoreType } from "./index"


/**
 * ExportColumnDtoBase
 * auto generated base class for the model ExportColumnDtoModel.
 */
export const ExportColumnDtoModelBase = ModelBase
  .named('ExportColumnDto')
  .props({
    __typename: types.optional(types.literal("ExportColumnDto"), "ExportColumnDto"),
    key: types.union(types.undefined, types.string),
    label: types.union(types.undefined, types.string),
    group: types.union(types.undefined, ExportColumnGroupEnumType),
    isCustomField: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ExportColumnDtoModelSelector extends QueryBuilder {
  get key() { return this.__attr(`key`) }
  get label() { return this.__attr(`label`) }
  get group() { return this.__attr(`group`) }
  get isCustomField() { return this.__attr(`isCustomField`) }
}
export function selectFromExportColumnDto() {
  return new ExportColumnDtoModelSelector()
}

export const exportColumnDtoModelPrimitives = selectFromExportColumnDto().key.label.group.isCustomField
